import SessionManager, { SessionManagerEvents } from "core/lib/session.manager";
import { appSettings } from "./config";
import AxiosInterceptorDatabaseLogger from "./logging/axios-interceptor-database-logger";
// import DatabaseStore from "./logging/database-store";
import ConnectService from "./services/connect.service";
import environment from "@environment";

ConnectService.options = appSettings.connect;

export const connectService = new ConnectService();

export const tokenCheckInterval = 1000 * 60 * 5; //1 sec in milliseconds * 60 secs * 5 mins

const tokenRefresh = environment.CONNECT.TOKEN_REFRESH_TIME;

const sessionEvents: SessionManagerEvents | undefined = environment.production
    ? undefined
    : {
        onExpiredToken: () => console.log("onExpiredToken"),
        onSignIn: () => console.log("onSignIn"),
        onSuccessfulAuth: (sessionManager: SessionManager) => {
            console.log("onSuccessfulAuth");
        },
        onTokenRefresh: (sessionManager: SessionManager) => {
            console.log("onTokenRefresh");
        },
        onStatusChange: (sessionManager: SessionManager) => {
            console.log("onStatusChange");
        },
        onAuthCodeVerificationError: (sessionManager: SessionManager, error: any) => {
            console.log("onAuthCodeVerificationError");
        },
        onExistingValidToken: (sessionManager: SessionManager) => {
            console.log("onExistingValidToken");
        },
        onTokenVerificationError: (sessionManager: SessionManager) => {
            console.log("onTokenVerificationError");
        },
        onSignOut: () => {
            console.log("onSignOut");
        }
    }

export const sessionManager = new SessionManager(tokenRefresh, sessionEvents);

const databaseName = "dstv.business";
// const storeName = "logsStore";

// export const logDatabase = new DatabaseStore(databaseName, 1, storeName);

const axiosStore = "responses";

export const axiosLogger = new AxiosInterceptorDatabaseLogger(databaseName, 2, axiosStore);
